import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import type { ApiXTdhGrantStatus } from "@/generated/models/ApiXTdhGrantStatus";
import { getStatusVisuals } from "../statusVisuals";
export function StatusBadge(t0) {
  const $ = _c(19);
  const {
    status,
    validFrom,
    validTo
  } = t0;
  let icon;
  let label;
  let t1;
  let t2;
  if ($[0] !== status || $[1] !== validFrom || $[2] !== validTo) {
    const {
      badgeClassName,
      icon: t3,
      label: t4
    } = getStatusVisuals(status, validFrom, validTo);
    icon = t3;
    label = t4;
    t1 = `${label} grant status`;
    t2 = clsx("tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-px-2.5 tw-py-1 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide", badgeClassName);
    $[0] = status;
    $[1] = validFrom;
    $[2] = validTo;
    $[3] = icon;
    $[4] = label;
    $[5] = t1;
    $[6] = t2;
  } else {
    icon = $[3];
    label = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const t3 = icon === faCircle ? "tw-size-2" : "tw-size-3";
  let t4;
  if ($[7] !== t3) {
    t4 = clsx("tw-leading-none", t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== icon || $[10] !== t4) {
    t5 = <FontAwesomeIcon icon={icon} aria-hidden="true" className={t4} />;
    $[9] = icon;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== label) {
    t6 = <span>{label}</span>;
    $[12] = label;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t5 || $[17] !== t6) {
    t7 = <output aria-label={t1} className={t2}>{t5}{t6}</output>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}